export enum NotificationMethod {
  TELEGRAM = 'telegram',
  MAIL="mail"
}